/**
 * Created by mykurisu on 2017/10/31.
 */
import React from 'react'
import {browserHistory} from 'react-router'
import {connect} from 'react-redux'
import {ActionSheet, Toast} from 'react-weui'
import axios from 'axios'
import qs from 'qs'
import {WKInfiniteScroll, WKSkeletonScreen} from '../../components/wk'
import {renderCouponMoney, renderMoney} from '../../utils'
import side from '../../images/coupon/coupon__side.png'
import selectedIcon from '../../images/coupon/selected.png'
import '../../css/common/CouponBar.css'


class CouponItem extends React.Component {

    renderScope() {
        const {content} = this.props;
        const {coupon} = content;
        switch (content.coupon.scope){
            case 'weike':
                return '点击券面查看';
            case 'liveroom':
                if (coupon.threshold_enabled) {
                    return `店铺内满￥${renderMoney(coupon.threshold_price)}可用`
                }
                return '店铺通用';
            case 'lecture':
                return `课程【${coupon.object_name}】`;
            case 'channel':
                return `专栏【${coupon.object_name}】`;
        }
    }

    isNoSuit () {
        const type = this.props.type
        const money = this.props.money
        const { threshold_enabled, threshold_price } = this.props.content.coupon
        if (!threshold_enabled) return false
        if (type !== 'liveroom') return false

        return threshold_price > money
    }

    render() {
        const {content} = this.props;
        const {coupon} = content;
        if (this.isNoSuit()) return null
        return (
            <div className="list__item" style={{opacity: content.coupon.scope === 'luck_coupon' ? '0.8' : '1'}} onClick={() => this.props.handleCouponSelected(coupon.id)}>
                <div className="item__left">
                    <div className="left__side">
                        <img src={side} alt=""/>
                    </div>
                    <div className="left__content">
                        <div className="content__price">
                            <span>￥</span>
                            <span>{renderCouponMoney(coupon.price)}</span>
                        </div>
                    </div>
                </div>
                <div className="item__right">
                    {content.selected &&
                    <div className="right__selected">
                        <img src={selectedIcon} alt=""/>
                    </div>
                    }
                    <div className="right__title">
                        {content.coupon.scope === 'weike' ? content.coupon.title : coupon.coupon_name}
                    </div>
                    {content.coupon.scope === 'luck_coupon' ?
                        <div className="right__message">
                            <p>
                                <span>全场通用</span>
                                <span></span>
                            </p>
                            <p>
                                <span>适用范围：</span>
                                <span>仅限APP</span>
                            </p>
                            {coupon.deadline &&
                            <p>
                                <span>有效期至：</span>
                                <span>{coupon.deadline}</span>
                            </p>
                            }
                        </div>
                    :
                        <div className="right__message">
                            {content.coupon.scope === 'weike' ?
                                <p>
                                    <span>平台优惠券</span>
                                    <span></span>
                                </p>
                                :
                                <p>
                                    <span>店铺：</span>
                                    <span>{this.props.liveroomName}</span>
                                </p>
                            }
                            {content.coupon.scope === 'weike' ?
                                <p>
                                    <span></span>
                                    <span></span>
                                </p>
                                :
                                <p>
                                    <span>适用范围：</span>
                                    <span>{this.renderScope()}</span>
                                </p>
                            }
                            {coupon.deadline &&
                            <p>
                                <span>有效期至：</span>
                                <span>{coupon.deadline}</span>
                            </p>
                            }
                        </div>
                    }
                </div>
            </div>
        )
    }
}

class CouponSelected extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            actions: [
                {
                    label: '我是土豪，不用优惠',
                    onClick: () => {
                        /*this.props.dispatch({
                            type: 'COUPON_SELECT_HIDE'
                        })*/
                        this.props.payMethod ? this.props.payMethod() : null
                    }
                }
            ],
            list: null,
            has_more: null,
            next_offset: null,
            loading: false,
            liveroomName: '',
            toast: false,
        }
    }

    getMoney (type) {
        if (type === 'lecture') {
            return this.props.lecture.lecture.limit_money && this.props.lecture.lecture.limit_money.money || this.props.lecture.lecture.money
        }
        if (type === 'channel') {
            return this.props.channel.channel.promoprice && this.props.channel.channel.promoprice.price || this.props.channel.channel.money
        }
        if (type === 'liveroom') {
            return this.props.vip_info && this.props.vip_info.vip_fee
        }
    }

    componentDidMount(){
        const {st, source_type} = this.props
        const money = this.getMoney(this.props.type)
        //提前加载ICON优化体验
        let img = new Image(0, 0);
        img.src = selectedIcon;
        let reqData = (st === 'channel_cps' || source_type === 'channel_cps') ? {money, is_cps: 1} : {money}
        //检测该页面是否有优惠券
        axios.get(`/api/coupon/${this.props.type}/${this.props.target_id}/check_has_coupons`, {
            params: reqData
        })
            .then(res => {
                if (res.data.code === 0){
                    if (res.data.data.has_active_coupons){
                        this.props.dispatch({
                            type: 'NEW_COUPON_CHECKED'
                        });

                        axios.get(`/api/coupon/${this.props.type}/${this.props.target_id}/receiver_coupons`, {
                            params: reqData
                        })
                            .then(res => {
                                if (res.data.code === 0) {
                                    let data = res.data.data.coupons;
                                    let canuse = data.find((item) => {
                                        return item.coupon_status === 'active' && item.coupon.scope !== 'luck_coupon'
                                    });
                                    if (canuse){
                                        this.props.dispatch({
                                            type: 'NEW_COUPON_DATA',
                                            payload: canuse.coupon
                                        });

                                        this.props.dispatch({
                                            type: 'COUPON_USE_BUY'
                                        });

                                        const routerLocation = browserHistory.getCurrentLocation();
                                        let params_kurisu = qs.parse(routerLocation.search.substr(1));
                                        if (params_kurisu.auto_pay_use_wkcoupon){
                                            let target = document.querySelector('.class_for_maincoupon');
                                            target.addEventListener('click', null);
                                            target.click()
                                        }
                                    }
                                }
                            })
                    }
                }
            });
    }

    componentWillReceiveProps(props) {
        const money = this.getMoney(this.props.type)
        if (props.newCoupon.selectCouponShow){
            axios.get(`/api/coupon/${this.props.type}/${this.props.target_id}/receiver_coupons`, {
                params: {
                    money: money
                }
            })
                .then(res => {
                    if (res.data.code === 0) {
                        res.data.data.coupons.forEach((item) => {
                            item.selected = false
                        });
                        this.setState({
                            list: res.data.data.coupons,
                            liveroomName: res.data.data.liveroom_name,
                            has_more: res.data.data.has_more,
                            next_offset: res.data.data.next_offset
                        });
                    }
                })
        }
    }

    componentWillUnmount() {
        this.props.dispatch({
            type: 'COUPON_CLEAR'
        })
        this.toasting && clearTimeout(this.toasting)
    }

    handleCouponSelected(id) {
        let pathname = window.location.pathname;

        let newlist = [].concat(this.state.list);
        let index = newlist.findIndex((item) => {
            return item.coupon.id === id
        });
        if (newlist[index].coupon.scope === 'luck_coupon') {
            this.setState({
                toast: true
            }, () => {
                this.toasting = setTimeout(() => {
                    this.setState({
                        toast: false
                    })
                }, 2000)
            })
            return
        }
        for (let i = 0;i < newlist.length;i++){
            newlist[i].selected = false;
            if (newlist[i].coupon.id === id) {
                newlist[i].selected = true;
            }
        }
        this.setState({
            list: newlist
        }, () => {
            this.props.dispatch({
                type: 'COUPON_SELECT_HIDE'
            });

            if (id){
                if (/lecture/.test(pathname)){
                    this.props.dispatch({
                        type: 'LECTURE_SET_DISCOUNT',
                        payload: newlist[index].coupon
                    })
                }else if (/channel/.test(pathname)){
                    this.props.dispatch({
                        type: 'CHANNEL_SET_DISCOUNT',
                        payload: newlist[index].coupon
                    })
                }else if (/liveroom/.test(pathname)){
                    this.props.dispatch({
                        type: 'NEW_COUPON_DATA',
                        payload: newlist[index].coupon
                    });
                }

                this.props.dispatch({
                    type: 'COUPON_SETTING',
                    payload: newlist[index].coupon.code
                });
                this.props.dispatch({
                    type: 'COUPON_DONT_WANT_USE',
                    payload: false
                });
            }else {
                this.props.dispatch({
                    type: 'COUPON_REMOVE',
                });
                /*this.props.dispatch({
                    type: 'COUPON_DONT_WANT_USE',
                    payload: true
                });
                this.props.dispatch({
                    type: 'CHANNEL_SET_DISCOUNT',
                    payload: null
                })*/
            }
        })
    }

    renderCouponList() {
        const object = this.props.type === 'channel' ? this.props.channel.channel : this.props.lecture.lecture
        const money = this.getMoney(this.props.type)
        return (
            <div className="couponbar__list">
                <div className="couponbar__list-title">
                    可用优惠券
                </div>
                {this.state.list ?
                    <div id="wrap" style={{overflowY: 'scroll', maxHeight: '245px'}}>
                        {this.state.list.map((item) => <CouponItem
                            key={item.coupon.id}
                            content={item}
                            money={money}
                            object={object}
                            type={this.props.type}
                            liveroomName={this.state.liveroomName}
                            handleCouponSelected={(id) => this.handleCouponSelected(id)}
                        />)}
                    </div>
                    :
                    <WKSkeletonScreen num={3}/>}
            </div>
        )
    }

    render() {
        return (
            <div className={`couponbar`}>

                <div id="wk__toast-coupon">
                    <Toast show={this.state.toast}>
                        <img src="https://static-cos.lycheer.net/picture/5459246_033f6f23e8b8dcb86d2e6b9d24b68c5f.jpg"/>
                        仅限APP
                        <br />
                        支付使用
                    </Toast>
                </div>

                <ActionSheet
                    menus={[{label: this.renderCouponList()}]}
                    show={this.props.newCoupon.selectCouponShow}
                    actions={this.state.actions}
                    type="ios"
                    onRequestClose={() => {
                        this.props.dispatch({
                            type: 'COUPON_SELECT_HIDE'
                        })
                    }}
                />

            </div>
        )
    }
}


export default connect(state => ({
    newCoupon: state.newCoupon,
    channel: state.channel,
    lecture: state.lecture,
}))(CouponSelected)



// WEBPACK FOOTER //
// ./src/components/details/CouponSelected.js